import { path, getPathPermission } from '+/utils/pathFinder';

export default (currentUser) => {
  const landingPathCookie = document.cookie.split(';').find(c => c.trim().startsWith('landingPath='));
  const landingPath = landingPathCookie && landingPathCookie.split('=')[1];

  if (landingPath) return landingPath;
  if (currentUser) return currentUser.homePath();
  const requiresSignin = !['any', 'loggedOut'].includes(getPathPermission(window.location.pathname));
  if (requiresSignin) return path('signin');
  return null;
};

export const setLandingPath = (pathname = window.location.pathname) => {
  const expire = new Date();
  expire.setTime(expire.getTime() + 10 * 60 * 1000);
  document.cookie = `landingPath=${pathname};expires=${expire.toUTCString()};path=/`;
};

export const deleteLandingPathIfOnIt = (pathname = window.location.pathname) => {
  const landingPathCookie = document.cookie.split(';').find(c => c.trim().startsWith('landingPath='));
  const landingPath = landingPathCookie && landingPathCookie.split('=')[1];

  if (pathname === landingPath) {
    document.cookie = 'landingPath=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }
};
